import { Component } from '@angular/core';
import { ListeZaehlerComponent } from "../liste-zaehler-component/liste-zaehler-component";
import { ListeZaehlerAntraegeComponent } from "../liste-zaehler-antraege-component/liste-zaehler-antraege-component";
import { RouterLink } from '@angular/router';

@Component({
  selector: 'app-home-page',
  imports: [
    ListeZaehlerComponent,
    ListeZaehlerAntraegeComponent,
    RouterLink
],
  templateUrl: './home-page.html',
  styleUrl: './home-page.css',
})
export class HomePage {}
